import { Drawer, Row, Col } from "antd";
import { HomeOutlined, CalendarOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import { useHistory } from "react-router-dom";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import Close from "../../../assets/images/close-x.svg";
import Back from "../../../assets/images/backIcon.svg";
import SyncSide from "../../../assets/images/sideFullSync.svg";
import Logout from "../../../assets/images/logout-new.svg";
import { processSync } from "../../Sync/syncData";
import useSyncProgressStore from "../../../stores/useSyncProgressStore";
import { message } from "antd";
import env from "../../../config/env";
import useSessionStore from "../../../stores/useSessionStore";
import dayjs from "dayjs";

const SideMenuDrawer = ({
  tillLink,
  setTillLink,
  setActiveInput,
  setSelectedDocumentType,
  searchInputRef,
  posConfig,
  isOnline,
  cart,
  tillData,
  setShowPreOrders,
  searchOrderHistory,
  setDateRange,
  handleCancel,
  domainURL,
}) => {
  const history = useHistory();
  const { resetProgress } = useSyncProgressStore();
  const version_number = env.releaseNo;

  return (
    <Drawer
      placement="left"
      width="20%"
      closable={false}
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={POSLogo} style={{ height: "2vw", cursor: "pointer" }} />
          <img
            src={Close}
            onClick={() => {
              setTillLink(false);
              setActiveInput("search");
              setSelectedDocumentType("Invoice");
              if (searchInputRef?.current) {
                searchInputRef?.current.focus();
              }
            }}
            style={{
              marginLeft: "auto",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      headerStyle={{ background: "#F3F4F9", borderBottom: "none" }}
      styles={{ body: { background: "#F3F4F9", paddingTop: 0, borderRadius: "none" } }}
      open={tillLink}
      onClose={() => setTillLink(false)}
    >
      <Row gutter={[16, 16]} style={{ fontSize: "1vw" }}>
        <Col span={24}>
          <Scrollbars style={{ height: "80vh" }}>
            <Row>
              {/* Back to POS */}
              <Col span={1} />
              <Col
                onClick={() => {
                  setTillLink(false);
                  history.push("/pos");
                }}
                style={{ display: "flex", alignItems: "center", cursor: "pointer", marginBottom: "2vh" }}
                span={22}
              >
                <img src={Back} style={{ height: "2.2vh" }} alt="" />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1.2em",
                    paddingLeft: "1vw",
                    color: "#0F0718",
                  }}
                >
                  Back to POS
                </span>
              </Col>
              <Col span={1} />

              {/* Home */}
              <Col span={1} />
              <Col
                onClick={() => {
                  setTillLink(false);
                  history.push("/");
                }}
                style={{ display: "flex", alignItems: "center", cursor: "pointer", marginBottom: "2vh" }}
                span={22}
              >
                <HomeOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1.2em",
                    paddingLeft: "1vw",
                    color: "#0F0718",
                  }}
                >
                  Home
                </span>
              </Col>
              <Col span={1} />

              {/* Manage Pre-Orders */}
              <Col span={1} />
              <Col
                onClick={() => {
                  setTillLink(false);
                  if (isOnline) {
                    const dateValue = [dayjs().startOf("day"), dayjs().add(7, "days").endOf("day")];
                    if (typeof setDateRange === "function") setDateRange(dateValue);
                    // Passing `true` (not an array) here made useOrderHistory fall through to its
                    // default of mirroring the Order Date range onto Delivery Date, silently hiding
                    // advance orders whose delivery date falls outside that window (BUG-1929).
                    if (typeof searchOrderHistory === "function") searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true, [null, null]);
                    setShowPreOrders(true);
                  } else {
                    message.error("Please check your network connection and try again");
                  }
                }}
                style={{ display: "flex", alignItems: "center", cursor: "pointer", marginBottom: "2vh" }}
                span={22}
              >
                <CalendarOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1.2em",
                    paddingLeft: "1vw",
                    color: "#0F0718",
                  }}
                >
                  Manage Pre-Orders
                </span>
              </Col>
              <Col span={1} />

              {/* Full Sync */}
              <Col
                span={1}
                style={{
                  display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                }}
              />
              {/* <Col
                span={22}
                onClick={async () => {
                  if (!isOnline) {
                    message.error("Please check your network connection and try again");
                    return;
                  }
                  setTillLink(false);
                  if (cart.items.length > 0) {
                    message.error("To perform a Full Sync, please clear the cart items!");
                    return;
                  }
                  useSessionStore.getState().setLastUpdatedTime(null);
                  try {
                    await processSync(tillData, "Full Sync");
                  } catch (e) {
                    console.warn("[PreOrderSideMenu] Full sync failed:", e?.message);
                    message.error("Sync failed. Please check your network and try again.");
                  }
                  resetProgress();
                }}
                style={{
                  cursor: "pointer",
                  display: posConfig?.enableFullSync === "Y" ? "flex" : "none",
                  alignItems: "center",
                  marginBottom: "2vh",
                }}
              >
                <img src={SyncSide} style={{ height: "2vh" }} alt="" />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1.2em",
                    paddingLeft: "1vw",
                    color: "#0F0718",
                  }}
                >
                  Full Sync
                </span>
              </Col> */}
              <Col
                span={1}
                style={{
                  display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                }}
              />
            </Row>
          </Scrollbars>
        </Col>
        <Col
          span={24}
          style={{
            width: "80%",
            borderTop: "1px solid #929098",
            position: "absolute",
            bottom: "2.5vh",
            padding: "1vh 1vw",
          }}
        >
          <Row>
            <Col span={1} />
            <Col
              style={{ display: "flex", alignItems: "center", cursor: "pointer", paddingTop: "1vh", marginBottom: 0 }}
              onClick={async () => {
                const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
                for (let i = 0; i < cookiesToDelete.length; i++) {
                  const cookie = cookiesToDelete[i];
                  const eqPos = cookie.indexOf("=");
                  const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                  const domain = "domain=" + domainURL;
                  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
                }
                useSessionStore.getState().setTillSession(null);
                window.location.assign("/till");
                handleCancel();
              }}
              span={20}
            >
              <img src={Logout} alt="" />
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "1.2em",
                  paddingLeft: "1vw",
                  color: "#0F0718",
                }}
              >
                Logout
              </span>
            </Col>
            <Col span={24} style={{ position: "absolute", bottom: "5vh", right: "0" }}>
              <p style={{ color: "#0f071840", textAlign: "right", paddingRight: "1vw", fontSize: "0.6rem", fontWeight: 400 }}>v{version_number}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Drawer>
  );
};

export default SideMenuDrawer;
